/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsDisconnect } from "../../funcs/accountsDisconnect.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DisconnectAccountRequest$inboundSchema,
};

export const tool$accountsDisconnect: ToolDefinition<typeof args> = {
  name: "accounts-disconnect",
  description:
    `This will sever the connection between you and the account specified and it will no longer be listed as 
active in the list of accounts. This also means you'll only have read-only access to the account going 
forward for reporting purposes.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/profile.disconnect\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsDisconnect(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
